const styles = theme => ({
    fullScreenContent: {
        marginTop: theme.spacing(2),
    },
    flex: {
        flex: 1,
    },
    menuItem: {
        '&:focus': {
            backgroundColor: theme.palette.background.paper,
            borderColor: theme.palette.background.paper,
        },
    },
    disabled: {
        opacity: 0.7
    },
    expiryDateLabel: {
        marginLeft: theme.spacing(1),
    }
});

export default styles;